import { render, staticRenderFns } from "./TotalsTable.vue?vue&type=template&id=4823f982&scoped=true"
import script from "./TotalsTable.vue?vue&type=script&lang=js"
export * from "./TotalsTable.vue?vue&type=script&lang=js"
import style0 from "./TotalsTable.vue?vue&type=style&index=0&id=4823f982&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4823f982",
  null
  
)

export default component.exports